import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { inject, observer } from "mobx-react";
import * as React from "react";
import { IOperatorRegionPrice } from "src/Interfaces/AdminInterface";
import { IOperator } from "src/Interfaces/WellInterface";
import PdfService from "src/Services/Pdf";
import { AdminStore } from "src/Stores/Admin/AdminStore";
import TenantStore from "src/Stores/Tenant/TenantStore";
import { UserStore } from "src/Stores/User/UserStore";

@inject('stores')
@observer
export default class OperatorRegionPriceListPdf extends React.Component {
    public props: any;
    private operator: IOperator;
    private AdminStore: AdminStore;
    public UserStore: UserStore;
    public TenantStore: TenantStore;
    
    public state = {
        operator: this.operator,
        priceList: [] as IOperatorRegionPrice[],
    };

    constructor(props: any) {
        super(props);

        this.UserStore = this.props.stores.UserStore;
        this.AdminStore = this.props.stores.AdminStore;
        this.TenantStore = this.props.stores.TenantStore;
    }

    public componentDidMount() {
        this.getOperatorData();
        this.getOperatorPriceList();
        if (!this.UserStore.user) {
            this.UserStore.getProfile();
        }
    }

    public componentDidUpdate() {
        this.renderIframe();
    }

    private renderIframe() {
        const myFrame: any = document.getElementById('my_frame');
        if (myFrame) {
            this.pdfReportString().then((data: any) =>
                myFrame.src = data
            );
        }
    }

    private getOperatorData = () => {
        this.AdminStore.getOperator(this.props.match.params.operatorId)
            .then(data => {
                if (data) {
                    this.setState({operator: data});
                }
            });
    }

    private getOperatorPriceList = () => {
        this.AdminStore.getOperatorPrices(this.props.match.params.operatorId, this.props.match.params.regionId)
            .then(data => {
                if (data) {
                    this.setState({priceList: data});
                }
            });
    }

    private pdfReportString = () => {
        return PdfService.createOperatorRegionPriceList(this.TenantStore.tenant, this.state.operator, this.props.match.params.regionId, this.state.priceList);
    }

    public render() {
        if ((this.state.operator === undefined ) || this.state.priceList.length === 0) {
            return (
                <FontAwesomeIcon 
                icon={faSpinner}
                spin={true}
                size={"8x"}
                style={{position: 'fixed', left: '50%', top: '35%'}}
            />
            );
        }
        return (
            <iframe id="my_frame" style={{width: '100%', height: '2000px'}} />
        );
    }


}


// WEBPACK FOOTER //
// ./src/Components/Reporting/OperatorRegionPriceListPdf.tsx